import React from 'react';
import { CtaButton } from './CtaButton';
export function StickyBar() {
  return <div className="sticky bottom-0 z-40 border-t-2 border-safety bg-concrete-950/95 backdrop-blur lg:hidden" data-id="element-182" data-mp="12lqwy6qs4h2p">
      <div className="flex items-center gap-4 px-4 py-3" data-id="element-183" data-mp="xu8sv9tgm0di">
        <div className="min-w-0 flex-1" data-id="element-184" data-mp="xspbtgzzblao">
          <p className="font-display text-lg uppercase leading-none text-concrete-50" data-id="element-185" data-mp="sw79ens4fz1i">
            $25 USD
          </p>
          <p className="truncate text-xs text-concrete-400" data-id="element-186" data-mp="nxdxgzshgg3g">
            Megapack + 5 bonos · Descarga hoy
          </p>
        </div>
        <CtaButton className="shrink-0 whitespace-nowrap" data-id="element-187" data-mp="jx3ulvzzm5st">Lo quiero</CtaButton>
      </div>
    </div>;
}